// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentEnrollPatientDefaultResponse {
    static getAttributeTypeMap() {
        return EnrollmentEnrollPatientDefaultResponse.attributeTypeMap;
    }
}
EnrollmentEnrollPatientDefaultResponse.discriminator = undefined;
EnrollmentEnrollPatientDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentV2ProcessingResultModel"
    }
];
//# sourceMappingURL=enrollmentEnrollPatientDefaultResponse.js.map